// Registro del service worker de la PWA (lo genera vite-plugin-pwa como
// `/sw.js`). Antes lo inyectaba el plugin en index.html (`registerSW.js`);
// ahora lo llama app/main.tsx para poder saltarlo en los subdominios de los
// sitios públicos, que no son la app. Mismo comportamiento que el script del
// plugin: registra al terminar de cargar la página.

export function registerServiceWorker(): void {
  const enabled = typeof __PWA_ENABLED__ !== "undefined" && __PWA_ENABLED__;
  if (!enabled || typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  const register = () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((error: unknown) => {
      console.warn("No se pudo registrar el service worker", error);
    });
  };
  if (document.readyState === "complete") register();
  else window.addEventListener("load", register, { once: true });
}
